import { RavenService } from '@cores/modules/raven-module/raven-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
/**
 * 使用 raven-js 的 hook
 * @description 不直接导入目的是隔离对 raven-js 的依赖
 * @example
 * // ❌ 错误的用法
 * import { rvTrack } from '@cores/services/tracker/bi';
 * rvTrack('event', { attr: 'value' });
 *
 * // ✅ 正确的用法
 * const { rvTrack } = useRaven();
 * rvTrack('event', { attr: 'value' });
 */
export const useRaven = createSharedComposable(() => {
    const ravenService = injectService(RavenService);
    function rvTrack(name, options = {}) {
        ravenService.track(name, options);
    }
    return {
        rvTrack,
    };
});
